module.exports = __webpack_public_path__ + "static/media/Internationalbanner@2x.2983eaf7.png";